import React, { useState, useEffect } from "react";
import {
    Box, Typography, CircularProgress, Card, CardHeader,
    Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemAvatar, ListItemText, Avatar
} from "@mui/material";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { app } from "../firebase";
import "./userhistory.css";

const UsersSearchHistory = () => {
    const [searchHistory, setSearchHistory] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const firestore = getFirestore(app);

    const fetchAllUsersHistory = async () => {
        try {
            const historyCollection = collection(firestore, "history");
            const historySnapshot = await getDocs(historyCollection);
            const allHistory = historySnapshot.docs.map(doc => ({
                userId: doc.id,
                data: doc.data()
            }));
            setSearchHistory(allHistory);
            setLoading(false);
        } catch (error) {
            console.error("Failed to fetch all users' search history:", error);
            setLoading(false);
            // Display a user-friendly error message or retry option
            // You can implement a toast message or error boundary here
        }
    };

    useEffect(() => {
        fetchAllUsersHistory();
    }, []);

    const formatDate = (timestamp) => {
        try {
            return timestamp.toDate().toLocaleDateString(undefined, {
                weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
            });
        } catch (error) {
            console.error("Failed to format date:", error);
            return "Invalid date";
        }
    };

    const formatTime = (timestamp) => {
        try {
            return timestamp.toDate().toLocaleTimeString([], {
                hour: '2-digit', minute: '2-digit'
            });
        } catch (error) {
            console.error("Failed to format time:", error);
            return "Invalid time";
        }
    };

    const groupByDate = (entries) => {
        const grouped = {};
        entries.forEach(entry => {
            const dateKey = formatDate(entry.timestamp);
            if (!grouped[dateKey]) {
                grouped[dateKey] = [];
            }
            grouped[dateKey].push(entry);
        });
        return grouped;
    };

    const handleClickOpen = (userHistory) => {
        setSelectedUser(userHistory);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedUser(null);
    };

    return (
        <Box sx={{ padding: '20px', backgroundColor: '#f0f0f0' }}>
            <Typography variant="h3" gutterBottom sx={{ color: '#333', textAlign: 'center' }}>
                Users Search History
            </Typography>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Grid container spacing={3} justifyContent="center">
                    {searchHistory.map((userHistory, index) => (
                        <Grid item xs={12} md={6} key={userHistory.userId} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Card sx={{ marginBottom: '20px', width: '100%', maxWidth: '500px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                <CardHeader
                                    title={`User: ${userHistory.userId}`}
                                    onClick={() => handleClickOpen(userHistory)}
                                    sx={{ backgroundColor: '#333', color: '#fff', cursor: 'pointer', textAlign: 'center' }}
                                />
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}

            {selectedUser && (
                <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
                    <DialogTitle>User: {selectedUser.userId}</DialogTitle>
                    <DialogContent>
                        <Typography variant="h6" gutterBottom>
                            Movie History
                        </Typography>
                        {Object.entries(groupByDate(selectedUser.data.movies ? selectedUser.data.movies.flatMap(entry =>
                            entry.timestamps.map(ts => ({
                                type: 'movie',
                                movieId: entry.movieId,
                                mediaTitle: entry.mediaTitle,
                                genres: entry.genres,
                                posterPath: entry.posterPath,
                                timestamp: ts
                            }))
                        ) : [])).map(([date, entries]) => (
                            <div key={date}>
                                <Typography variant="subtitle1" sx={{ color: '#666' }}>{date}</Typography>
                                <List>
                                    {entries.map((entry, idx) => (
                                        <ListItem key={idx} alignItems="flex-start">
                                            <ListItemAvatar>
                                                <Avatar variant="square" src={`https://image.tmdb.org/t/p/w500${entry.posterPath}`} />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={entry.mediaTitle}
                                                secondary={`Genres: ${entry.genres.join(', ')} - ${formatTime(entry.timestamp)}`}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </div>
                        ))}

                        <Typography variant="h6" gutterBottom sx={{ marginTop: '20px' }}>
                            TV Show History
                        </Typography>
                        {Object.entries(groupByDate(selectedUser.data.tvShows ? selectedUser.data.tvShows.flatMap(entry =>
                            entry.timestamps.map(ts => ({
                                type: 'tv',
                                tvId: entry.tvId,
                                mediaTitle: entry.mediaTitle,
                                genres: entry.genres,
                                posterPath: entry.posterPath,
                                timestamp: ts
                            }))
                        ) : [])).map(([date, entries]) => (
                            <div key={date}>
                                <Typography variant="subtitle1" sx={{ color: '#666' }}>{date}</Typography>
                                <List>
                                    {entries.map((entry, idx) => (
                                        <ListItem key={idx} alignItems="flex-start">
                                            <ListItemAvatar>
                                                <Avatar variant="square" src={`https://image.tmdb.org/t/p/w500${entry.posterPath}`} />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={entry.mediaTitle}
                                                secondary={`Genres: ${entry.genres.join(', ')} - ${formatTime(entry.timestamp)}`}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </div>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </Box>
    );
};

export default UsersSearchHistory;
